<template>
  <div class="shareholders">
    <MoreTitle title="股本结构" @click="goPage('change')" />
    <div class="section-item edge-padding section-margin">
      <EquityChange />
    </div>
    <div class="section-item" :class="{ 'section-margin': market === 'us' }">
      <MoreTitle title="主要股东" @click="goPage('shareholders')" />
      <MajorShareholders />
    </div>
    <InstitutionalShareholding v-if="market === 'us'" />
  </div>
</template>

<script>
import EquityChange from '@/components/f10/shareholders/equityChange/EquityChange.vue'
import MajorShareholders from '@/components/f10/shareholders/majorShareholders/MajorShareholders.vue'
import InstitutionalShareholding from '@/components/f10/shareholders/InstitutionalShareholding.vue'
export default {
  components: {
    EquityChange,
    MajorShareholders,
    InstitutionalShareholding
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  },
  methods: {
    goPage(type) {
      this.$router.push({
        path: '/f10/shareholders',
        query: {
          symbol: this.$route.query.symbol,
          type
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.section-item {
  padding-bottom: var(--edge-padding);
  background: var(--bg-color-2);
}
</style>
